import DTO from './DTO';

class SubscriptionDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'subs.id',
      },
      {
        name: 'lpn',
        type: String,
        validators: [],
        labelKey: 'subs.lpn',
      },
      {
        name: 'lpns',
        type: Array,
        validators: [],
        labelKey: 'subs.lpns',
      },
      {
        name: 'card_uid',
        type: String,
        validators: [],
        labelKey: 'subs.card_uid',
      },
      {
        name: 'comment',
        type: String,
        validators: [],
        labelKey: 'subs.comment',
      },
      {
        name: 'is_active',
        type: Boolean,
        validators: [],
        labelKey: 'subs.is_active',
      },
      {
        name: 'is_vip',
        type: Boolean,
        validators: [],
        labelKey: 'subs.is_vip',
      },
      {
        name: 'is_lpn_exact',
        type: Boolean,
        validators: [],
        labelKey: 'subs.is_lpn_exact',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default SubscriptionDTO;
